import { ComponentType } from 'react';
import ArticlesBase from '@/creditflowresearch/ui/components/creditFlow/articles/Articles';
import { withArticlesConfig } from '@/creditflowresearch/ui/components/creditFlow/articles/withArticlesConfig';
import { useRegionBasedArticlesConfig } from '@/creditflowresearch/ui/components/creditFlow/articles/config/adapters';
import { IMarketArticlesData } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';

interface IRegionBasedArticlesProps {
  articlesData: IMarketArticlesData,
}

export const RegionBasedArticles: ComponentType<IRegionBasedArticlesProps> = withArticlesConfig(ArticlesBase, useRegionBasedArticlesConfig);

export default RegionBasedArticles;
